var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-filter",
    { ref: "filter-component" },
    [
      _c("app-input", {
        attrs: { type: "text", label: _vm.t("app-email") },
        on: { input: _vm.refresh },
        model: {
          value: _vm.properties.delegate.search,
          callback: function ($$v) {
            _vm.$set(_vm.properties.delegate, "search", $$v)
          },
          expression: "properties.delegate.search",
        },
      }),
      _vm._v(" "),
      _c("app-select", {
        attrs: {
          label: _vm.t("app-account-type"),
          options: _vm.accountTypeOptions,
        },
        on: { input: _vm.refresh },
        model: {
          value: _vm.properties.delegate.accountType,
          callback: function ($$v) {
            _vm.$set(_vm.properties.delegate, "accountType", $$v)
          },
          expression: "properties.delegate.accountType",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }